import React from 'react';
import TemplateManagement from '../../../Components/Utils/TemplateManagement/TemplateManagement';
import { ITab } from '../../../Types/ITab';

const tabs: ITab[] = [
  {
    title: "Active",
    active: true,
    url: "/admin/manage-templates/active"
  },
  {
    title: "Archive",
    active: false,
    url: "/admin/manage-templates/archive"
  }
];

type AdminTemplateBankItemsProps = {
  // Add props here if needed in the future
};

const AdminTemplateBankItems = ({}: AdminTemplateBankItemsProps) => {
  return (
    <TemplateManagement 
      tabs={tabs}
      showCreateButton={false}
      showTitleEdit={true}
      mesmaOnly={false} // Admin controls show mandated templates, not Mesma templates
    />
  );
};

export default AdminTemplateBankItems;